import lottie from 'lottie-web';

document.querySelectorAll('[data-animation-src]').forEach(element => {
	const path = element.dataset.animationSrc;
	element = element.querySelector('a') ? element.querySelector('a') : element;
	const animation = lottie.loadAnimation({
		container: element,
		renderer: 'svg',
		loop: true,
		autoplay: true,
		path: path
	});
	animation.goToAndPlay(0, true);
	animation.addEventListener('DOMLoaded', (event) => {
		if(element.querySelector('img')) {
			copyAttributes(element.querySelector('img'), element.querySelector('svg'));
			element.querySelector('img').remove();
		}
	});
	// console.log(animation);
});

function copyAttributes(source, target) {
	const ignoreAttributes = [
		'height',
		'width',
	];
	return Array.from(source.attributes).filter(attribute => !ignoreAttributes.includes(attribute.nodeName)).forEach(attribute => {
		target.setAttribute(
			attribute.nodeName,
			attribute.nodeValue,
		);
	});
}